import styled from 'styled-components'

const hexToRgba = (hex: string, alpha: number) => {
  const normalized = hex.replace('#', '')
  const r = parseInt(normalized.slice(0, 2), 16)
  const g = parseInt(normalized.slice(2, 4), 16)
  const b = parseInt(normalized.slice(4, 6), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export const LabelBadgeContainer = styled.span<{
  $color: string
  $backgroundColor?: string
  $width?: string
  $clickable?: boolean
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0.55rem;
  background: ${({ $backgroundColor, $color }) =>
    $backgroundColor ?? hexToRgba($color, 0.133)};
  color: ${({ $color }) => $color};
  border: 1px solid ${({ $color }) => $color};
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  width: ${({ $width }) => $width ?? 'auto'};
  box-sizing: border-box;
  white-space: nowrap;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
`
